import { Record } from 'immutable';

import Hydrator from 'utils/Hydrator';
import { formatCurrency } from 'utils/NumberHelper';

import { ProductTypeLabel } from 'enums/product-type';

import CreditLineFacilityAccountInfo from './CreditLineFacilityAccountInfoModel';

const CreditLineFacilityRecord = Record({
  id: '',
  accountType: '',
  providerId: 0,
  providerName: '',
  productType: 0,
  amount: 0,
  period: 0,
  logoUrl: '',
  account: null,
  overdraftLimit: 0,
  interestAccount: null,
  lenderName: '',
  productName: '',
  matchedProducts: [],
  subProductName: '',
  rate: 0,
  paymentAmount: 0,
  sweep: '',
  cardholderName: '',
  totalRepayment: 0,
  interestFreePeriod: new Date(0),
  capitalRepaymentHoliday: new Date(0),
  sortCode: '',
  startDate: new Date(0),
  endDate: new Date(0),
});

export default class CreditLineFacility extends CreditLineFacilityRecord {
  static deserialize(jsonObject = {}) {
    const mapProperties = {
      interestFreePeriod: Hydrator.timestamp2Date,
      capitalRepaymentHoliday: Hydrator.timestamp2Date,
      startDate: Hydrator.timestamp2Date,
      endDate: Hydrator.timestamp2Date,
      account: CreditLineFacilityAccountInfo.deserialize,
      interestAccount: CreditLineFacilityAccountInfo.deserialize,
    };

    const hydrated = Object.keys(jsonObject).reduce(Hydrator.assign(jsonObject, mapProperties), {});

    return new CreditLineFacility(hydrated);
  }

  get productTypeLabel() {
    return this.accountType || ProductTypeLabel[this.productType];
  }

  get isCreditCard() {
    return this.accountType === 'credit card';
  }

  get formattedOverdraftLimit() {
    return this.overdraftLimit ? formatCurrency(this.overdraftLimit) : '-';
  }
}
